import { VitalsInputErrorMsg } from "@common/models/Enums/CommonAlertMessages";

export const Required = { required: "Required" };
export const MaxLength = (num: number) => ({
  value: num,
  message: `Max ${num} characters`,
});
export const MinLength = (num: number) => ({
  value: num,
  message: `Min ${num} characters`,
});
export const Patterns = {
  /** letters and numbers */
  alphaNum: {
    value: /^[A-Za-z0-9]*$/,
    message: "Only numbers and letters are allowed.",
  },
  /** numbers */
  integer: {
    value: /^[0-9]*$/,
    message: "Only numbers are allowed.",
  },
  /** numbers and periods */
  decimal: {
    value: /^[+-]?([0-9]*[.])?[0-9]+$/,
    message: "Only numbers and decimals are allowed.",
  },
  /** numbers, letters, and symbols */
  nonWhiteSpace: {
    value: /[^\s]/,
    message: "Must have at least one number, letter, or symbol",
  },
  /** xxx-xxx-xxxx */
  phoneWithDashes: {
    value: /^[0-9]{3}[-][0-9]{3}[-][0-9]{4}$/i,
    message: "Must have 10 digits",
  },
  email: {
    value:
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
    message: "Must be in the form of @email.com",
  },
  url: {
    value:
      /^((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www\.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w\-_]*)?\??(?:[-+=&;%.\w_]*)#?(?:[.!/\\\w]*))?)$/i,
    message: "Must be in the form https://petco.com/hospital",
  },
  /** 1-5 digits */
  zipCodeAny: {
    value: /^[0-9]{1,5}$/i,
    message: "Zip Code must be 1 to 5 digits.",
  },
  /** 5 digits exactly */
  zipCodeFull: {
    value: /^[0-9]{5}$/i,
    message: "Zip Code must be 5 digits.",
  },
  nationwideIdPattern: {
    value: /^[-A-Za-z0-9]{8,10}$/,
    message: "Formats allowed: 12345678 or X-12345678",
  },
  temperaturePattern: {
    value: /^(?:9[89]|10[0-6])|0$/,
    message:VitalsInputErrorMsg.TEMPERATURE
  },
  pulsePattern: {
    value: /^(?:3[5-9]|[4-9][0-9]|1[0-9]{2}|20[0-9]|210)|0$/,
    message:VitalsInputErrorMsg.PULSE
  },
};
